<div class="auth-entry d-flex flex-column flex-grow-1">
  <div class="d-flex align-items-center px-3 py-2 position-relative flex-shrink-0 entry-header">
    @if (!isLoginPage) {
      <div class="entry-logo-wrapper">
        <img src="assets/images/logo.png" class="entry-logo" alt="RDA">
      </div>
    }
    <language-switch class="entry-lang-switch" />
  </div>
  <div class="flex-grow-1 overflow-auto">
    <router-outlet />
  </div>
</div>
